import ComparisonPageTestimonial from "@components/ComparisonPageV2/ComparisonPageTestimonial";
import FeatureCard, { FeatureCardItemProps } from "@components/FeatureCardV2";
import BenefitsCard from "@components/Gallabox-benefits/benefitsCard";
import HeroButton from "@components/HeroButton";
import PageMainTitleCard from "@components/LandingPageComponents/PageMainTitleCard";
import ClientLogos from "@components/new-ui/ClientLogos";
import LPLayout from "@components/new-ui/LPLayout";
import YellowCTAhref from "@components/yellowCTAhref";
import React from "react";

const featureCardInput: FeatureCardItemProps[] = [
    {
        chipTitle: "Contact Segmentation",
        title: "Personalized engagement at scale",
        description: "Offer a more personal and conversational experience compared to generic landing pages and increase lead engagement and capture more detailed information.",
        mediaType: "image",
        mediaUrl: "https://assets.gallabox.com/gb-home/wa-marketing/featurecard/segment.png",
        mediaAltText: "Contact Segmentation",
        mediaPosition: "right",
    },
    {
        chipTitle: "Lead Scoring",
        title: "Intelligent Lead Scoring with AI-powered Chatbot ",
        description:
            "When leads click your ad, our advanced chatbot seamlessly takes control and prioritises leads based on their readiness to buy through a WhatsApp conversation.",
        mediaType: "image",
        mediaUrl: "https://assets.gallabox.com/gb-home/wa-marketing/featurecard/leadScore.png",
        mediaAltText: "Reply-to Configuration",
        mediaPosition: "left",
    },
    {
        chipTitle: "Lead Qualification Bot",
        title: (
            <p className="text-3xl font-bold text-gray-700 lg:text-left text-center">
                Smart Qualification
                <br />
                Through Engaging Questions
            </p>
        ),
        description:
            "Our customizable templates, tailored to your industry, campaign goals, and buyer cycle, ask insightful questions that gauge lead interest and purchase intent.",
        mediaType: "image",
        mediaUrl: "https://assets.gallabox.com/gb-home/wa-marketing/featurecard/assistViaBot.png",
        mediaAltText: "Campaign Performance",
        mediaPosition: "right",
    },
    {
        chipTitle: "AI Translate",
        title: "Real-Time Language Translation",
        description:
            "Our built-in translation ensures clear communication, regardless of the lead's language. The chatbot translates Arabic to English for your reps, and vice versa for the lead, all within the WhatsApp window.",
        mediaType: "image",
        mediaUrl: "https://assets.gallabox.com/gb-home/wa-marketing/featurecard/ai_Translate.png",
        mediaAltText: "Abandoned cart triggers",
        mediaPosition: "left",
    },
];

const benefitCards = [
    {
        icon: "https://assets.gallabox.com/gb-home/wa-marketing/benefitsCard/lead-icon.png",
        title: "Increase lead quality",
        backgroundColor: "#EBF8FF",
        textColor: "#2B6CB0",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/wa-marketing/benefitsCard/team-icon.png",
        title: "Improve sales team efficiency",
        backgroundColor: "#F0FFF4",
        textColor: "#25855A",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/wa-marketing/benefitsCard/shortconversation-icon.png",
        title: "Shorter conversion time",
        backgroundColor: "#E6FFFA",
        textColor: "#2C7A7B",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/wa-marketing/benefitsCard/scale-icon.png",
        title: "Scale your lead generation",
        backgroundColor: "#E6F3FF",
        textColor: "#0069CC",
    },
];

const WhatsappBroadcast: React.FC = () => {
    return (
        <LPLayout
            title="Maximize Marketing ROI with Gallabox WhatsApp Automation"
            description=" Increase your marketing ROI by 3X through personalized messaging, automated workflows, ai powered functionalities and more, all on WhatsApp."
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/wa-marketing/og.png" }}
        >
            <PageMainTitleCard
                mainTitle={<h2 className="lg:text-5xl lg:leading-tight text-2xl font-bold text-blue-500 py-4">3x Your Marketing ROI with WhatsApp Automation</h2>}
                description="Are you tired of passing unqualified leads to your sales team? Gallabox can help you boost your lead quality and conversion rates with AI powered WhatsApp Chatbot."
                mediaType="image"
                mediaUrl="https://assets.gallabox.com/gb-home/wa-marketing/hero-image.png"
                mediaAltText="Social media post promoting a digital marketing course with chatbot interaction, offering details and WhatsApp registration."
                primaryButton={<HeroButton buttontext="Start Free Trial" />}
                showKeyFeatures={true}
            />

            <div className="lg:max-w-7xl mx-auto">
                <h3 className="text-base text-center font-normal py-2">
                    10,000+ Customers <span className="font-normal"> Who Get More Out of Their Broadcasts</span>
                </h3>
                <ClientLogos />
            </div>

            <BenefitsCard
                title={
                    <span>
                        What&#39;s In It for <span className="text-blue-500">You</span>, Marketing Maestro? ✨
                    </span>
                }
                benefitCards={benefitCards}
            />

            <FeatureCard mobileView="content-first" cardData={featureCardInput} />

            <section className="mt-20 mb-20 md:mx-0 mx-4">
                <h4 className="text-center text-4xl font-bold">Why Marketers love us? ❤️</h4>
                <ComparisonPageTestimonial
                    quotationText='"A seamless, user-friendly collaborative tool every marketing team needs"'
                    question="What do you like best about Gallabox?"
                    description={
                        <p className="text-gray-500 text-sm md:text-lg font-normal px-9 md:px-0">
                            Gallabox support team is very responsive. Special shout out to Allavuddin from the onboarding team & Aswin from the support team. They have been very
                            supportive from the start. he helped us coordinate with tech team to deploy contact details masking feature for us which is not a GA feature. Gald I
                            migrated from Interakt.
                            <br />
                            <br />
                            The team had supported me with customizarions that i required. Now I have connected my D365 and it working smoothly
                        </p>
                    }
                    founderName="Vindhya K"
                    companyName="Marketing Manager - Kachins"
                    starFill={["full", "full", "full", "full", "full"]}
                />
            </section>

            <div className="my-10 lg:mx-auto mx-2">
                <YellowCTAhref
                    buttonText="Start Free Trial"
                    customText={<h3 className="text-2xl font-bold text-yellow-800">Become the lead whisperer your sales team has been dreaming of!</h3>}
                />
            </div>
        </LPLayout>
    );
};

export default WhatsappBroadcast;
